angular.module('impactx.catalog').controller('CatalogRuleListCtrl',
    CatalogRuleListCtrl);

CatalogRuleListCtrl.$inject = ['$scope', '$routeParams', 'CatalogRuleService', '$redirect', 'selectedListItems'];

function CatalogRuleListCtrl($scope, $routeParams, CatalogRuleService, $redirect, selectedListItems)
{
    var ctrl = this;
    var catId = $routeParams.catId;
    
    ctrl.toggleStatus = function() {
        CatalogRuleService.toggleStatus(selectedListItems.getFirstSelectedId());
    };

    ctrl.runRuleCheck = function(event, trns)
    {
        CatalogRuleService.runRuleCheck($routeParams.catId, trns.ruleCheckStarted);
        $scope.$$childHead.data.actions.runRuleCheck.allowed = false;
    };
    
    ctrl.ignore = function(){
        CatalogRuleService.ignoreRules(catId, selectedListItems.getSelectedIds(), false);
    };

    ctrl.unIgnore = function(){
        CatalogRuleService.unIgnoreRules(catId, selectedListItems.getSelectedIds(), false);
    };

    ctrl.canIgnoreRules = function (additionalFields) {
        if (additionalFields && additionalFields.canIgnoreRules && selectedListItems.isMultiSelection())
        {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                var item = selectedItems[i];
                if (item.isIgnored.value || item.status != 1 || item.deleted) {
                    return false;
                }
            }
            return true;
        }
        else
        {
            return false;
        }
    };

    ctrl.canUnIgnoreRules = function(additionalFields){
        if (additionalFields && additionalFields.canIgnoreRules && selectedListItems.isMultiSelection())
        {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                var item = selectedItems[i];
                if (!item.isIgnored.value || item.status != 1 || item.deleted) {
                    return false;
                }
            }
            return true;
        }
        else
        {
            return false;
        }
    };

    ctrl.getDetailsLink = function() {
        return "catalogruledetail/"+selectedListItems.getFirstSelectedId()+"/"+catId;
    };

    ctrl.canDeactivate = function() {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().deleted &&
            selectedListItems.getFirstSelectedItem().status == 1 &&
            !selectedListItems.getFirstSelectedItem().readOnly.value &&
            selectedListItems.getFirstSelectedItem().ruleUsageInt == 3;
    };

    ctrl.canActivate = function() {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().deleted &&
            selectedListItems.getFirstSelectedItem().status == 2 &&
            !selectedListItems.getFirstSelectedItem().readOnly.value &&
            selectedListItems.getFirstSelectedItem().ruleUsageInt == 3;
    };

    ctrl.getChecksLink = function() {
        if(impactX.isDefined($scope, "$$childHead.data.actions.isCheckedOutCat.allowed")){ // not the best but it works here
            return "catalogrulecheckcheckedoutlist/"+catId;
        }
        return "catalogrulechecklist/"+catId;
    };
    
    ctrl.canRunRuleCheck = function() {
        return selectedListItems.isNoSelection() && impactX.isDefined($scope, '$$childHead.data.actions.runRuleCheck.allowed'); // not the best but it works here
    };
    
    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailsLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'CatalogRule'},
        {label: "deactivate", action: ctrl.toggleStatus, condition: ctrl.canDeactivate, process: 'CatalogRule'},
        {label: "activate", action: ctrl.toggleStatus, condition: ctrl.canActivate, process: 'CatalogRule'},
        {label: "ignore", action: ctrl.ignore, condition: ctrl.canIgnoreRules, process: 'CatalogRuleIgnore'},
        {label: "unignore", action: ctrl.unIgnore, condition: ctrl.canUnIgnoreRules, process: 'CatalogRuleIgnore'},
        {label: "catrulechecks", linkFunction: ctrl.getChecksLink, type:'link', condition: selectedListItems.isNoSelection, process: 'CatalogRule'},
        {label: "runRuleCheck", action: ctrl.runRuleCheck, condition: ctrl.canRunRuleCheck, process: 'CatalogRule'}
        ];
    
    ctrl.meta = {
        rowTemplate: 'modules/catalog/templates/catalogrulelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalog/rulelist',
        id: "catalogrulelist",
        params: {'catId': catId},
        catId: catId,
        mainAction : {id:"new", link: "#/catalogruledetail/0/" + catId , icon:"mdi-plus"},
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: 'CatId', value: $routeParams.catId}]
    };
    ctrl.getMeta = function () {
        return ctrl.meta;
    };
}